import { ElementType, createContext, useContext } from "react";

import type { DialogResult } from "./Dialog.types";

export interface DialogContextValue {
  openModal: <Props>(Component: ElementType<Props>, props?: Props) => Promise<DialogResult<unknown>>;
}

const DialogContext = createContext({} as DialogContextValue);

function useDialog() {
  return useContext(DialogContext);
}

export { DialogContext, useDialog };
